const blockRoots = document.querySelectorAll(
	'.wp-block-blocks-albertlikhanov-block-family'
);

blockRoots.forEach( ( blockRoot ) => {

	const openButtons = blockRoot.querySelectorAll( '[data-popup-target]' );

	// Переносим все попапы в document.body, чтобы position:fixed
	// работал относительно вьюпорта, а не родителей с transform
	const popups = blockRoot.querySelectorAll( '.popup' );
	popups.forEach( ( popup ) => {
		popup.classList.add( 'wp-block-blocks-albertlikhanov-block-family-popup' );
		document.body.appendChild( popup );
	} );

	const closePopup = ( popup ) => {
		popup.setAttribute( 'hidden', '' );
	};

	const openPopup = ( popup ) => {
		popup.removeAttribute( 'hidden' );
	};

	openButtons.forEach( ( button ) => {
		button.addEventListener( 'click', () => {
			const targetId = button.getAttribute( 'data-popup-target' );

			if ( ! targetId ) {
				return;
			}

			const popup = document.getElementById( targetId );
			if ( ! popup ) {
				return;
			}

			openPopup( popup );
		} );
	} );

	popups.forEach( ( popup ) => {
		const closeButtons = popup.querySelectorAll( '[data-popup-close]' );

		closeButtons.forEach( ( closeButton ) => {
			closeButton.addEventListener( 'click', () => {
				closePopup( popup );
			} );
		} );
	} );

	document.addEventListener( 'keydown', ( event ) => {
		if ( event.key !== 'Escape' ) {
			return;
		}

		popups.forEach( ( popup ) => {
			if ( ! popup.hasAttribute( 'hidden' ) ) {
				closePopup( popup );
			}
		} );
	} );
} );
